// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import './GetClientComp.css';
import { Row, Col } from 'react-flexbox-grid';
import MdCheckCircle from 'react-icons/lib/md/check-circle';
import MdUncheckCircle from 'react-icons/lib/md/radio-button-unchecked';
import WizardActions from '../actions/wizard.actions';
import { bindActionCreators } from 'redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import Button from '../common/ButtonComp';
// import LinkImage from '../assets/img/link.png';
import LinkImage from 'react-icons/lib/md/insert-link';
import RightAngleImage from '../assets/img/right-angle.png';
import Input from 'react-toolbox/lib/input';
import qs from 'query-string';
import MdHelpOutline from 'react-icons/lib/md/help-outline';
import Tooltip from 'react-toolbox/lib/tooltip';
import Link from 'react-toolbox/lib/link';
import FontIcon from 'react-toolbox/lib/font_icon';
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import StripeCheckout from 'react-stripe-checkout';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import WordpressIcon from '@fortawesome/fontawesome-free-brands/faWordpress';
import PHPIcon from '@fortawesome/fontawesome-free-brands/faPhp';
// import BloggerIcon from '@fortawesome/fontawesome-free-brands/faBlogger';

import { routerActions } from 'react-router-redux';
import { getTranslate } from 'react-localize-redux';
const TooltipLink = Tooltip(Link);
const dataLayer = window.dataLayer;

const cms = [
  {
    icon: WordpressIcon,
    name: 'Wordpress'
  },
  {
    icon: PHPIcon,
    name: 'PHP'
  },
  {
    icon: null,
    name: 'Other Integrations'
  }
];

class GetClientComp extends Component {
  state = {
    selectedItem: cms[0],
    cms
  };
  constructor(props) {
    super(props);
    const {
      query: { idx = 0 },
      project
    } = this.props;
  }
  goBack() {
    const {
      query: { idx = 0 },
      routerActions
    } = this.props;
    routerActions.push(`select-plan?idx=${idx}`);
  }

  selectCmsItem(element) {
    this.setState({
      selectedItem: element
    });
  }
  componentDidMount() {
    const {
      query: { idx = 0 },
      routerActions,
      project
    } = this.props;
    if (project.wizard[1] !== 'select-plan') routerActions.push(`select-plan?idx=${idx}`);
  }
  goNext() {
    const {
      query: { idx = 0 },
      project: { _id },
      wizardActions,
      routerActions
    } = this.props;
    wizardActions.setClientDone({
      id: _id,
      cb: () => routerActions.push(`/wizard/seo-perfomance?idx=${idx}`)
    });
  }

  render() {
    const {
      me: { user },
      query,
      goals,
      translate,
      wizard: { plans, wizardSaving },
      project,
      env: { STRIPE_PUBLISHABLE_KEY }
    } = this.props;

    const { cms, selectedItem } = this.state;

    const cmsElems = cms.map((item, i) => {
      const { name, icon } = item;
      const isActive = item === selectedItem ? 'active' : '';
      const className = `cms-list-item ${isActive}`;

      return (
        <div
          key={i}
          onClick={() =>
            this.setState({
              selectedItem: item
            })
          }
          className={className}
        >
          <div className="cms-list-left-group">
            {icon && <FontAwesomeIcon className="cms-list-item-icon" icon={icon} />}
            {name}
          </div>
          <div className="cms-list-item-right-icon">
            <img src={RightAngleImage} />
          </div>
        </div>
      );
    });

    return (
      <div className="wizard-get-client-comp">
        <h1>{translate('wizard.get_client.title')}</h1>
        <p className="space-big-bottom">{translate('wizard.get_client.description')}</p>

        <Row>
          <Col xs={12}>
            <CopyToClipboard
              onCopy={() => {
                this.input.focus();
              }}
              text={project.apiKey}
            >
              <div className="copy-container">
                <div className="left-group">
                  <div>
                    <LinkImage className="copy-icon" />
                  </div>
                  <div className="api-key">
                    <Input
                      className="wizard-get-client-input"
                      onFocus={(e) => e.target.select()}
                      innerRef={(e) => (this.input = e)}
                      value={project.apiKey}
                    />
                  </div>
                </div>

                <div className="copy-btn">{translate('wizard.get_client.copy')}</div>
              </div>
            </CopyToClipboard>
          </Col>
        </Row>

        <Row className="cms-description">
          <Col xs={12}>
            <Row>
              <Col className="how-to-start" xs={12}>
                {`${translate('wizard.get_client.how_to_start')}?`}
              </Col>
            </Row>
            <Row className="cms-list-selector">
              <Col xs={4}>
                <div className="cms-list">{cmsElems}</div>
              </Col>

              <Col xsOffset={1} xs={7}>
                <div className="instructions">
                  {translate(
                    `wizard.get_client.${selectedItem.name.replace(' ', '_').toLowerCase()}_text`
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="kwh-button-group">
          <Button big secondary onClick={this.goBack.bind(this)}>
            {translate('app.back')}
          </Button>
          <Button big primary onClick={this.goNext.bind(this)} loading={wizardSaving}>
            {translate('app.next')}
          </Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    project: {
      accounts,
      webProperties,
      accountsUpdating,
      webPropertiesUpdating,
      webPropertiesCreating
    }
  } = state;

  const query = search ? qs.parse(search) : { idx: 0 };
  const { projects = [] } = state.me.user;
  if (query.id) {
    const { index = 0 } = projects.find(({ _id }) => _id === query.id) || {};
    query.idx = index;
  }

  return {
    translate: getTranslate(state.locale),
    wizard: state.wizard,
    query,
    me: state.me,
    project: projects.find(({ index }) => index == query.idx),
    env: state.env
  };
}

function mapDispatchToProps(dispatch) {
  return {
    wizardActions: bindActionCreators(WizardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GetClientComp);



// WEBPACK FOOTER //
// ./src/wizard/GetClientComp.js